export const activateProgramEnrollmentDefault = '{\n' +
    '    "contractId": "",\n' +
    '    "programName": "",\n' +
    '    "version": ""\n' +
    '}';

export interface IActivateProgramEnrollmentRequest {
    contractId: string;
    programName: string;
    version: string;
}
